import React, { useState } from 'react';
import Popup from "../imagepopup";


function Sony() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };


  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p30.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                As a UI/UX Designer, I was responsible for designing and developing the Sony Card application, which provides rewards, membership benefits, and exclusive offers to Sony customers. Focused on delivering a modern, visually appealing, and seamless user experience, ensuring ease of use for cardholders to track rewards, redeem offers, and manage their accounts effectively.
                </p>
                <p className="mt-15">
                Designed intuitive interfaces for account management, transaction tracking, and loyalty rewards programs, enhancing customer engagement and satisfaction. Utilized wireframing, prototyping, and front-end development to create a high-performance, user-friendly digital platform.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Designer</strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      User Experience Research & Analysis: Conducted user research, persona development, and usability testing to enhance customer journeys.
                      </h6>
                    </li>
                    <li className="mt-20">
                       <h6 className="inline fz-15">
                       Wireframing & Prototyping: Created interactive wireframes and prototypes using Adobe Photoshop, and Axure to define seamless user interactions.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Rewards & Membership Portal UI: Designed the Sony Card rewards dashboard, enabling users to track points, redeem rewards, and access exclusive Sony offers.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Transaction & Account Management UI: Developed user-friendly interfaces for managing transactions, payments, and account details.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Responsive & Mobile-First Design: Ensured cross-device compatibility, making the application accessible on desktop, tablets, and mobile devices.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Branding & Visual Consistency: Maintained Sony’s brand identity across all UI elements, ensuring a premium and engaging experience.

                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance & Accessibility Optimization: Designed interfaces with fast-loading UI components, adhering to WCAG accessibility standards.
 
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Product & Development Teams: Worked closely with developers, business analysts, and Sony stakeholders to align the design with business objectives and technical feasibility.
                      </h6>
                    </li>
                  </ul>
                  <p className="mt-25">
                  This project helped deliver a highly interactive and engaging Sony Card experience, enhancing customer retention, loyalty rewards management, and digital engagement for Sony users worldwide.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>Jan 2009</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Designer</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Sony</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p31.jpg" alt=""   onClick={() => handleImageClick("/assets/imgs/works/p31.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/aspirezone">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/zome">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
                                    
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Sony;
